export enum UIPattern {
  STANDARD = 'Standard Offer',
  STEPPER = 'Locked Offer Progress Bar',
  LIST = 'Locked Offer List',
  PROMO = 'Promo Code Offer',
  CART_PROMO = 'Cart Promo Code',
  ERROR = 'Error Text',
  UPCOMING_OFFER = 'Upcoming Offer',
}
